import React from 'react';
import Box from '@mui/material/Box';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const SourceStoryIcon = ({ momentCount = 0 }) => {
  return (
    <Box
      data-testid="source-story-icon"
      title={`Organized care story — ${momentCount} ${momentCount === 1 ? 'moment' : 'moments'}`}
      sx={{
        position: 'relative',
        width: 34,
        height: 34,
        borderRadius: '12px',
        flexShrink: 0,
        bgcolor: alpha(colors.brand.tint, 0.18),
        color: colors.brand.deep,
      }}
    >
      <HubOutlinedIcon sx={{
        position: 'absolute',
        inset: 0,
        m: 'auto',
        fontSize: 22,
        color: colors.brand.deep,
      }} />
    </Box>
  );
};

export default SourceStoryIcon;
